import ModalContainer from 'components/ModalContainer'
import TransferActivityDetail from './TransferActivityDetail'

const TransferActivityDetailModal = ({ showModal, setShowModal }) => (
  <ModalContainer
    title='Comprobante'
    className='!max-w-md'
    isShown={showModal}
    setModalFunction={setShowModal}
  >
    <TransferActivityDetail />
  </ModalContainer>
)

export default TransferActivityDetailModal
